import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("armony_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Un 403 puede significar que el admin cambió los permisos de esta sesión:
// AuthContext escucha este evento y vuelve a cargar el usuario (y su menú).
api.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 403) window.dispatchEvent(new Event("armony:forbidden"));
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail: any): string {
  if (detail == null) return "Ocurrió un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  // Errores por campo: {message, fields: {campo: texto}}; el detalle lo muestra cada formulario.
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

/** Mensaje para la persona a partir de un error de axios (incluye la falta de conexión). */
export function apiError(err: any): string {
  if (err?.response) return formatApiErrorDetail(err.response.data?.detail);
  if (err?.request) return "No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.";
  return "Ocurrió un error. Inténtalo de nuevo.";
}
